/**
 * Slugify MongoDB `form_name` → stable CSS hook for per-form Form.io overrides.
 * e.g. "Accomodation Form" → "formio-form-accomodation-form"
 */
export function formNameToCssClass(formName) {
  const slug = String(formName || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return slug ? `formio-form-${slug}` : "";
}
